import styled from 'styled-components';
import { Flex } from '../../layout/Flex';

export const ListItem = styled(Flex)
    .withConfig({ displayName: 'ListItem' })
    .attrs((props) => ({
        ...props,
        borderRadius: 1,
        cursor: 'pointer',
        width: '100%',
        direction: 'row',
        spacing: 2,
        alignItems: 'center',
    }))`
    &:hover {
        background-color: var(--background-secondary);
    }
`;
